// @flow
import React, { Component, Fragment } from "react";
import "./styles.css";

// this stuff is unnecessary since it presupposes a redux format for props, which is not being used in this component

// type Props = {
//     teams: ?Object,
//     trashDrops: ?Object,
//     teamMembers: ?Object,

// };

const setSort = Symbol("@@_SET_SORT");

/**
 * sets sort by and direction
 * @param {string} sortBy - field to sort by
 * @returns {Function} - sort function
 * @private
 */
function _setSort(sortBy) {
    return () => {
        const nextSort = this.state.sortDirection === "asc" ? "desc" : "asc";
        const sortDirection = sortBy === this.state.sortBy ? nextSort : "asc";
        this.setState({ sortBy, sortDirection });
    };
}

export default class LeaderBoard extends Component<Props> {
    constructor(props) {
        super(props);
        this[setSort] = _setSort.bind(this);
        this.state = { sortBy: "bags", sortDirection: "asc" };

    }

    render() {
        const { sortBy, sortDirection } = this.state;
        const { teams, trashDrops, teamMembers } = this.props;
        
        const activeClassName = ` is-active ${sortDirection === "asc" ? "is-ascending" : "is-descending"}`;

        // this is John's original user bag drop total which is used in the team drop calculator
        
        // const dropsByUser = Object
        //     .values(trashDrops || {})
        //     .reduce((drops, drop) => ({ ...drops, [(drop.createdBy || {}).uid]: (drops[(drop.createdBy || {}).uid] || 0) + (drop.bagCount || 0) }), {});

        // console.log(Object.entries(trashDrops)[0][1].teamId) // teamId for which bags were dropped
        // console.log(Object.entries(trashDrops)[0][1].bagCount) // number of bags dropped for said team
         
        const dropsByTeam = Object.values(trashDrops || {})
            .reduce((drops, drop) => ({ ...drops, [(drop.teamId || {})]: (drops[(drop.teamId || {})] || 0) + (drop.bagCount || 0) }), {});
        console.log(dropsByTeam)

        // this is John's original bag count calculator

        // const dropsByTeam = Object.entries(teams) 
        //     .reduce((obj, team) => {
        //         const memberDrops = (Object.keys(team[1].members || {}))
        //             .map(memberUID => dropsByUser[memberUID] || 0)
        //             .reduce((a, b) => a + b, 0);
        //             // console.log(Object.keys(team[1]))
        //         return { ...obj, [team[0]]: memberDrops };
        //     }, {});
        
        const _rankings = (Object.entries(teams || {}));

        const rankings = _rankings.map(entry => {
            const teamId = entry[0];
            const team = entry[1];
            const bagDrops = dropsByTeam[teamId] || 0;
            const membership = Object.keys(team.members || {}).length;
            return { id: teamId, name: team.name, bagDrops, membership };
        })
            .sort((a, b) => {
                const aName = (a.name || "").toLowerCase();
                const bName = (b.name || "").toLowerCase();
                switch (sortBy) {
                    case "name":
                        return sortDirection === "asc" ? (bName < aName ? 1 : -1) : (bName > aName ? 1 : -1);
                    case "membership":
                        return sortDirection === "asc" ? b.membership - a.membership : a.membership - b.membership;
                    default:
                        return sortDirection === "asc" ? b.bagDrops - a.bagDrops : a.bagDrops - b.bagDrops;
                }
            })
            .map((team, index) => (<Fragment key={team.id}>
                <span className={"leader-board--ranking"}><span>{sortDirection === "asc" ? index + 1 : _rankings.length - index}</span></span>
                <span className={"leader-board--ranking-team-name"}><span>{team.name}</span></span>
                <span className={"leader-board--ranking"}><span>{team.bagDrops}</span></span>
                <span className={"leader-board--ranking"}><span>{team.membership}</span></span>
            </Fragment>));

        return (
            <article className={"leader-board"}>
                <h3 className={"leader-board--header"}>{"Team Rankings"}</h3>
                <div className={"leader-board--rankings"}>
                    <span className={"leader-board--ranking-header"}><span>{"#"}</span></span>

                    <span className={"leader-board--ranking-header"}>
                        <button
                            className={`leader-board--sort-button${sortBy === "name" ? activeClassName : ""}`}
                            onClick={this[setSort]("name")}>
                            {"Team"}
                        </button>
                    </span>
                    <span className={"leader-board--ranking-header"}>
                        <button
                            className={`leader-board--sort-button${sortBy === "bags" ? activeClassName : ""}`}
                            onClick={this[setSort]("bags")}>
                            {"Bags"}
                        </button>
                    </span>
                    <span className={"leader-board--ranking-header"}>
                        <button
                            className={`leader-board--sort-button${sortBy === "membership" ? activeClassName : ""}`}
                            onClick={this[setSort]("membership")}>
                            {"Members"}
                        </button>
                    </span>
                    {rankings}
                </div>
            </article>
        );
    }
}

